<template>
    <div class="socialevents">
        <h2 class="card-title">Photo Gallery</h2>
        <p style="font-size: 20px; font-weight: 400;">Explore our collection of photos, videos, and event highlights
            showcasing life at Lagos Lawn Tennis Club</p>
            <div class="row">
            <div class="cards col-md-4 mb-4" v-for="(card, index) in dataList" :key="index">
              <GalleryCard 
                :title="card.title" 
                :content="card.description.length > 100 ? card.description.substring(0, 100) + '...' : card.description"
                :image="card.image"
                :date="card.date"
                @click="openImagePopup(card.image)"
              />
            </div>
          </div>

    </div>
    <!-- IMAGE POPUP -->
  <div v-if="showPopup" class="popup-overlay" @click="closePopup">
    <div class="popup-content" @click.stop>
      <img :src="popupImage" alt="Preview Image" />
      <button class="close-btn" @click="closePopup">×</button>
    </div>
  </div>

</template>

<script setup>
import GalleryCard from "./CommonCard/GalleryCard.vue";
import axios from 'axios';
import { ref, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouter, useRoute } from 'vue-router';

const route = useRoute();
const router = useRouter();

let base_url = process.env.VUE_APP_BASE_LIVE_URL
const dataList = ref([]);
const showPopup = ref(false);
const popupImage = ref("");

watch(
  () => route.query.archive,
  () => {
    listGallery();
  }
);

onMounted( async () => {
  await listGallery();
});

onBeforeUnmount( async () => {
  
});
// Action methods
const openImagePopup = (img) => {
  popupImage.value = img;
  showPopup.value = true;
};
const closePopup = () => {
  showPopup.value = false;
};

const listGallery = async () => {
  try {

    const archive = route.query.archive;

    const response = await axios.get('/photo_gallery_list_all.php', { 
      params: archive ? { archive } : {}
    });

    dataList.value = response.data.data.map(data => ({
      title: data.title,
      description: data.description,
      date: data.date,
      image: `${base_url}/${data.banner_image}` // Construct full image path
    }));

  } catch (error) {
    console.error(error.message);
  }
};
/* eslint-disable */
const openDetails = (card)=>{
  router.push({
    name: "PhotoGalleryDetails",
    params: {
      title: card.title
    }
  });
}
</script>

<style scoped lang="scss">
.socialevents {
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
}

.btn-active {
    background-color: #ED4E24;
    color: #fff;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border: 2px solid #ED4E24;
    border-radius: 60px;
    width: 103px;
}

.btn-not-active {
    background-color: #fff;
    border: 2px solid #9B9A9A;
    color: #9B9A9A;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border-radius: 60px;
    width: 103px;

}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
}

.cards {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 1rem;
    cursor: pointer;
}
.card-title{
    font-size: 48px; 
    font-weight: 400;
}
@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .cards {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 5rem;
    }
    .card-title{
        font-size: 35px; 
    }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  overflow: hidden; /* prevent body scrolling */
}

.popup-content {
  position: relative;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;      /* <-- enable scrolling */
  background: transparent;
  border-radius: 10px;
}

/* Image stays full width but scrolls vertically */
.popup-content img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
}

/* Close button */
.close-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 24px;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.3);
  z-index: 10000;
}

</style>
